module.exports = __webpack_public_path__ + "static/media/patent-04.4399f04c.jpg";